import React, { useEffect, useState, PureComponent } from 'react';

import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';


import { Checkbox } from "./UI";

import db from "../firebase";
import { doc, getDocs, collection, onSnapshot, setDoc, getDoc, query, where, order, orderBy } from "firebase/firestore";

export default function NotificationsList ({hideNotificationsList, notifications}) {

	console.log(1);
	console.log(notifications);

	const [NotificationsList, setNotificationsList] = useState([]);

	const getUsers = async () => {

		for (let notificationsID in notifications){

			if (!notifications[notificationsID]['users'])
				notifications[notificationsID]['allUsers'] = true;

			if (!notifications[notificationsID]['userNames']){
				notifications[notificationsID]['userNames'] = [];

				for (let key in notifications[notificationsID]['users']){

					let ref = await doc(db, "users", notifications[notificationsID]['users'][key]);
					let snap = await getDoc(ref);
					let user = snap.data();

					if (user){
						notifications[notificationsID]['userNames'].push(user.firstName);
					}
				}
			}

		}
		console.log(2);
		console.log(notifications);

		setNotificationsList ([...notifications]);
	}

	useEffect(() => {

		getUsers();

    }, []);

    return (

        <div className="wrapper">
			<div className="modal">

				<div className="header">

					<h2>Notifications list</h2>

					<div className="cancel" onClick={hideNotificationsList}>
						<Cancel/>
						Close
					</div>

				</div>

				<div className="notifications-list">

					{NotificationsList.length > 0 ?

						NotificationsList.map( (notification, notificationIndex) =>

							<div className="notification__item" key={notificationIndex}>

								<div className="notification__left">

									{notification.email.subject != '' || notification.email.html != '' ?
										<>
											<h3>Email</h3>
											<div>subject: {notification.email.subject}</div>
											<div  dangerouslySetInnerHTML={{__html: notification.email.html}}>
											</div>
										</>

										: null
									}

									{notification.sms != '' ?

										<>
											<h3>SMS</h3>
											<div className="notification__description">{notification.sms}</div>
										</>

										: null
									}

								</div>
								<div className="notification__right">

									<div className="notification__users">
										{
											notification.allUsers ?
												<div className="notification__users__title">All Users</div>
											:

												notification.userNames ?
													<>
														<div className="notification__users__title">Users:</div>
														{ notification.userNames.map( (userName, userIndex) =>
															<div className="notification__user" key={userIndex}>
																{userName}
															</div>
														)}
													</>

												: null

										}
									</div>

								</div>

							</div>

						)

						:

						<div className="empty-notifications">
							No notifications yet
						</div>

					}


				</div>


			</div>
		</div>

    )

}

